/* globals wc_bookings_admin_js_params */
import { __, sprintf } from '@wordpress/i18n';
import jQuery from "jquery";

jQuery( function ( $ ) {
	// Create a bookable product.
	$( '.wc-use-templates' ).on( 'click', function ( e ) {
		e.preventDefault();

		const button = $( this );
		const dashicon = button.find( '.dashicons' );
		const template = button.parents( '.template-loop-item' );
		const dataIndex = template.data( 'template-index' );
		const dataSlug  = template.data( 'template-slug' );

		// Return if already clicked.
		if ( button.hasClass( 'active' ) ) {
			return false;
		}

		// Show the loader inside the button.
		button.addClass( 'active' );
		dashicon.addClass( 'dashicons-update' );
		dashicon.addClass( 'spin' );
		dashicon.css( 'display', 'inline-block' );

		$.ajax( {
			type: 'POST',
			url: wc_bookings_admin_js_params.ajax_url,
			data: {
				action: 'wc_bookings_get_product_template',
				index: dataIndex,
				slug: dataSlug,
				security: wc_bookings_admin_js_params.nonce.wc_bookings_get_product_template,
			},
			success: function ( result ) {
				result = JSON.parse( result );

				// Remove the loader.
				button.removeClass( 'active' );
				dashicon.removeClass( 'dashicons-update' );
				dashicon.css( 'display', 'none' );

				// Check for failure.
				if ( ! result.success ) {
					alert( result.data ); // eslint-disable-line no-alert

					return false;
				}

				if (
					0 ===
					$( '.template-item-popup-content .insertion-result' ).length
				) {
					// Creating the <p> element.
					const paragraph = document.createElement( 'p' );
					paragraph.className = 'insertion-result';

					paragraph.innerHTML = sprintf(
						/* translators: 1: Open anchor tag html 2: Close anchor tag html */
						__(
							'A bookable product is created using this template. Please %1$sclick here%2$s if you are not redirected automatically.',
							'woocommerce-bookings'
						),
						`<a href="${ result.data }">`,
						'</a>'
					);

					$( '.template-item-popup-content' ).append( paragraph );
				}

				// Reload to the newly created bookable product's edit screen.
				window.location.href = result.data;
			},
			error: function ( jqXHR, exception ) {
				if ( 'abort' === exception ) {
					return; // Assuming the date is changed very quickly.
				}

				// Show the error.
				alert( jqXHR.responseText ); // eslint-disable-line no-alert

				// Remove the loader.
				button.removeClass( 'active' );
				dashicon.removeClass( 'dashicons-update' );
			},
			dataType: 'html',
		} );
	} );

	// Open the popup when the button is clicked.
	$( '.template-loop-item' ).on( 'click', function ( e ) {
		e.stopPropagation();

		const $body = $( 'body' );

		// Stop if the arrow or the popup-inner side is clicked.
		if (
			$( e.target ).closest( '.item-popup-arrow' ).length !== 0 ||
			$( e.target ).closest( '.template-item-popup-inner' ).length !== 0
		) {
			return false;
		}

		// Add overlay only if it doesn't exist.
		if ( ! $( '#active-template-popup-overlay' ).length ) {
			$body.prepend(
				'<div id="active-template-popup-overlay"></div>'
			);
		}

		$body.addClass( 'noscroll' );
		$( '.template-item-popup' ).fadeOut();
		$( this ).find( '.template-item-popup' ).addClass( 'active' ).fadeIn();

		$body.trigger( 'wc_bookings_template_clicked', [ $( this ).data( 'template-index' ), $( this ).data( 'template-slug' ), $( this ) ] );
	} );

	// Close the popup when clicked outside or a close button.
	$( '.close-template-popup' ).on( 'click', function ( e ) {
		e.stopPropagation();
		$( '.template-item-popup' ).fadeOut();
		$( this ).parents( '.template-item-popup' ).removeClass( 'active' );
		$( '#active-template-popup-overlay' ).remove();
		$( 'body' ).removeClass( 'noscroll' );
	} );

	$( document ).on( 'click', function ( e ) {
		if (
			$( e.target ).closest( '.template-item-popup-inner' ).length === 0
		) {
			$( '.close-template-popup' ).trigger( 'click' );
		}
	} );

	// Close popup on Esc key press.
	$( document ).on( 'keyup', function ( e ) {
		const activePopupEl = $( '.active.template-item-popup' );

		// Return if popup is not open.
		if ( ! activePopupEl.length ) {
			return;
		}

		switch ( e.key ) {
			case 'ArrowLeft':
				activePopupEl
					.find( '.item-popup-arrow.left' )
					.trigger( 'click' );
				break;
			case 'ArrowRight':
				activePopupEl
					.find( '.item-popup-arrow.right' )
					.trigger( 'click' );
				break;

			case 'Escape':
				activePopupEl
					.find( '.close-template-popup' )
					.trigger( 'click' );
				break;
		}
	} );

	// On arrow click, show next/prev popup.
	$( '.item-popup-arrow' ).on( 'click', function () {
		const direction = $( this ).hasClass( 'left' ) ? 'left' : 'right';
		const currentPopupCard = $( this ).closest( '.template-loop-item' );

		// Remove active class from all popup cards.
		currentPopupCard.find( '.template-item-popup' ).removeClass( 'active' );

		if ( 'left' === direction ) {
			let prevPopupCard = currentPopupCard.prev();
			prevPopupCard = prevPopupCard.length
				? prevPopupCard
				: currentPopupCard.siblings().last();
			prevPopupCard.trigger( 'click' );
		} else {
			let nextPopupCard = currentPopupCard.next();
			nextPopupCard = nextPopupCard.length
				? nextPopupCard
				: currentPopupCard.siblings().first();
			nextPopupCard.trigger( 'click' );
		}
	} );
} );
